import TabOverdue from "@component/TabOverdue/TabOverdue";

function Overdue() {
  return <TabOverdue />;
}

export default Overdue;
